"use client";
import * as S from "./styles.ts";
import { DocumentationCard } from "./DocumentationCard";
import { H3, P, UniversalLink } from "@template/components";
import { DocumentationApiCategoryType } from "@/lib/types/documentation.ts";

type Page = {
  name: string;
  key: string;
  description: string;
};

type Category = {
  name: string;
  key: string;
  description: string;
  icon: string;
  objects: Page[];
};

interface IDocsOverviewSectionComponentProps {
  linkData: Category[];
  type: DocumentationApiCategoryType;
}

const DocsOverviewSectionComponent = ({
  linkData,
  type,
}: IDocsOverviewSectionComponentProps) => {
  const copy = type === "domain-names" ? "Domain Name" : "VoIP";
  return (
    <S.ApiDocumentationWrapper>
      <S.ApiDocumentationContainer>
        <H3> {copy} API Documentation</H3>
        {type === "domain-names" ? (
          <P>
            This is where we update the REST API documentation for our
            comprehensive, lightning quick Domain Reseller API. Using our robust
            and reliable Domain Name API you can create, renew and transfer
            domains, manage their DNS zones and records, and easily configure
            services such as email and domain forwarding
          </P>
        ) : (
          <P>
            This is where we update the REST API documentation for our
            comprehensive VoIP API. Using our VoIP API you can completely
            control phone numbers and SIP accounts across our completely
            controllable VoIP phone system.{" "}
            <UniversalLink
              href="https://www.yay.com/blog/api/beginners-guide-part-1/"
              {...{ style: { color: "#EA1B4B" } }}
            >
              You can read the beginners guide here.
            </UniversalLink>
          </P>
        )}

        <S.DocumentationCardsContainer>
          {linkData.map((item, index) => {
            const pageKey = item.objects.find((item) => item.key);
            return (
              <DocumentationCard
                key={index}
                title={item.name}
                description={item.description}
                itemKey={item.key}
                pageKey={pageKey?.key || ""}
                context={type}
              />
            );
          })}
        </S.DocumentationCardsContainer>
      </S.ApiDocumentationContainer>
    </S.ApiDocumentationWrapper>
  );
};

export default DocsOverviewSectionComponent;
export const options = [
  {
    description: "",
    displayName: "DocsOverviewSectionComponent",
    methods: [],
    props: {
      linkData: {
        required: true,
        flowType: {
          name: "Array",
          elements: [
            {
              name: "signature",
              type: "object",
              raw: "{\n  name: string;\n  key: string;\n  description: string;\n  icon: string;\n  objects: Page[];\n}",
              signature: {
                properties: [
                  {
                    key: "name",
                    value: {
                      name: "string",
                      required: true,
                    },
                  },
                  {
                    key: "key",
                    value: {
                      name: "string",
                      required: true,
                    },
                  },
                  {
                    key: "description",
                    value: {
                      name: "string",
                      required: true,
                    },
                  },
                  {
                    key: "icon",
                    value: {
                      name: "string",
                      required: true,
                    },
                  },
                  {
                    key: "objects",
                    value: {
                      name: "Array",
                      elements: [
                        {
                          name: "signature",
                          type: "object",
                          raw: "{\n  name: string;\n  key: string;\n  description: string;\n}",
                          signature: {
                            properties: [
                              {
                                key: "name",
                                value: {
                                  name: "string",
                                  required: true,
                                },
                              },
                              {
                                key: "key",
                                value: {
                                  name: "string",
                                  required: true,
                                },
                              },
                              {
                                key: "description",
                                value: {
                                  name: "string",
                                  required: true,
                                },
                              },
                            ],
                          },
                        },
                      ],
                      raw: "Page[]",
                      required: true,
                    },
                  },
                ],
              },
            },
          ],
          raw: "Category[]",
        },
        description: "",
      },
      type: {
        required: true,
        flowType: { name: "DocumentationApiCategoryType" },
        description: "",
      },
    },
  },
];
